import Swiper from "swiper";

/**
 * コモンクラス
 * @constructor
 */
class SwipeSlider {
  constructor() {

  }
  /**
   * コモン
   */
  init() {

    /* slider */
    /*** asahiwrap Product Features ***/
    var swiper_asahiwrap_product = {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<li class="' + className + '">' + '<button>' + '</button>' + '</li>';
            },
        },
        breakpoints: {
            750: {
                slidesPerView: 1,
                spaceBetween: 0,
            }
        }
    }
    /*** cookper Product Features01 ***/
    var swiper_cookper_product01 = {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next-cookperwrap01',
            prevEl: '.swiper-button-prev-cookperwrap01',
        },
        pagination: {
            el: '.swiper-pagination-cookperwrap01',
            clickable: true,
            renderBullet: function (index, className) {
                return '<li class="' + className + '">' + '<button>' + '</button>' + '</li>';
            },
        },
        breakpoints: {
            750: {
                slidesPerView: 1,
                spaceBetween: 0,
            }
        }
    }
    /*** cookper Product Features02 ***/
    var swiper_cookper_product02 = {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next-cookperwrap02',
            prevEl: '.swiper-button-prev-cookperwrap02',
        },
        pagination: {
            el: '.swiper-pagination-cookperwrap02',
            clickable: true,
            renderBullet: function (index, className) {
                return '<li class="' + className + '">' + '<button>' + '</button>' + '</li>';
            },
        },
        breakpoints: {
            750: {
                slidesPerView: 1,
                spaceBetween: 0,
            }
        }
    }

    $(window).on("load", function () {
        var asahiwrap01 = new Swiper('.j-swiper-asahiwrap01', swiper_asahiwrap_product);
        var cookperwrap01 = new Swiper('.j-swiper-cookperwrap01', swiper_cookper_product01);
        var cookperwrap02 = new Swiper('.j-swiper-cookperwrap02', swiper_cookper_product02);
    });
  }

}

export default SwipeSlider;
